// Song/artist -> wrap report links (matched by name; preview and live use different ids).
const SONG_WRAPS = {
  "brent faiyaz|lovely": "lovely",
  "brent faiyaz|no one knows": "no-one-knows",
  "brent faiyaz|poison": "poison",
  "jean deaux|immaculate": "immaculate",
};
const RECAP_ARTISTS = new Set(["brent faiyaz", "jean deaux"]);
const norm = (s) => (s || "").trim().toLowerCase();

export const songWrapSlug = (artistName, songTitle) => SONG_WRAPS[`${norm(artistName)}|${norm(songTitle)}`] || null;
export const artistHasRecap = (artistName) => RECAP_ARTISTS.has(norm(artistName));
